var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"featured-dorms__list dorm-card__list user__list-wrp"},[_c('container',[_c('div',{staticClass:"user__list-offer"},[_c('offers')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }